import axios from 'axios'
import { extractError } from '../utils/errorHandler'

/**
 * Depósitos de estoque (o "local" dos lotes) e as estações que podem usar os lotes de cada um.
 * Depósito sem estações = qualquer estação.
 */
export const getAll = async () => {
  try {
    const { data } = await axios.get('stockLocation')
    return data || []
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}

/** Grava descrição e estações do depósito. workStationIds vazio = qualquer estação. */
export const save = async ({ location, description, workStationIds }) => {
  try {
    const { data } = await axios.put('stockLocation', {
      location,
      description,
      workStationIds: workStationIds || [],
    })
    return data
  } catch (err) {
    const apiError = extractError(err)
    throw new Error(apiError.message || apiError.Message)
  }
}
